import { useSelector } from "react-redux";
import { AppState } from "../store";

export function useTrackingProperties() {
  const drugstore = useSelector((state: AppState) => state.permissions.current_drugstore);
  const user = useSelector((state: AppState) => state.permissions.user);

  if (!drugstore) {
    return {
      drugstoreId: 0,
      chainId: 0,
      drugstoreName: '',
      drugstoreUF: '',
      chainName: '',
    }
  }
  const { id, chain, uf } = drugstore;
  const { name: drugstoreName } = user;

  return {
    drugstoreId: id,
    chainId: chain.id,
    drugstoreName,
    chainName: chain.name,
    drugstoreUF: uf,
  }
}